<div role="separator" class="divider divider-center {{class}}">
    <div class="divider-content"><span>{{text}}</span></div>
</div>